import Service from "../../../Services/index";

const produceReport = {
    namespaced: true,
    state: {
        data: [],
        dataPaginate:{
            current_page :1,
            from : 1,
            last_page : 1,
            per_page : 1,
            total : 1,
            to : 1
        }
    },
    mutations: {
        GET_PRODUCE_REPORT: (state, res) => {
            state.data = res.data;
            state.dataPaginate = {
                current_page : res.current_page,
                from : res.form,
                last_page : res.last_page,
                per_page : res.per_page,
                total : res.total,
                to : res.to
            };
        }
    },
    actions: {
        setProduceReport({ commit },page=1) {
            return Service.produceReport.getReport(page).then(response => {
                commit("GET_PRODUCE_REPORT", response); //call mutation
            });
        }
    }
};

export default produceReport;
